import { create } from 'zustand'

type AppSourceState = {
  appSource: Record<string, unknown> | null
  isAppSourceResolved: boolean
  setAppSource: (source: Record<string, unknown> | null) => void
}

const useAppSourceStore = create<AppSourceState>(set => ({
  appSource: null,
  isAppSourceResolved: false,
  setAppSource: appSource =>
    set({
      appSource,
      isAppSourceResolved: true,
    }),
}))

export const useAppSource = () => useAppSourceStore(state => state.appSource)

export const useIsAppSourceResolved = () =>
  useAppSourceStore(state => state.isAppSourceResolved)

export const useSetAppSource = () =>
  useAppSourceStore(state => state.setAppSource)
